// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./ArrowDownIcon.data";

export const ArrowDownIcon = createIcon("ArrowDownIcon", iconNode);
